import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useRecoilState, useSetRecoilState } from 'recoil'
import { Paths } from 'src/navigation'
import { usePostPisPaymentCallback } from 'src/networking/terminals/pis/pis.gates'
import { atomPaymentData, atomPisPaymentId } from 'src/storage'

export const usePaymentFailure = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { crossGate: postPisPaymentCallback } = usePostPisPaymentCallback()
  const [pisPaymentId, setPisPaymentId] = useRecoilState(atomPisPaymentId)
  const setPaymentData = useSetRecoilState(atomPaymentData)

  useEffect(() => {
    setPaymentData(undefined)
    if (pisPaymentId) {
      postPisPaymentCallback(
        {
          body: {
            transactionId: pisPaymentId,
          },
        },
        {
          onSuccess: () => {
            setPisPaymentId(undefined)
          },
          onFailure: () => {
            setPisPaymentId(undefined)
          },
        }
      )
    }
  }, [])

  return {
    t,
    goBack: () => navigate(Paths.PolicyConfiguration),
  }
}
